import { styled } from "@mui/material";

import twToCss from "utils/twToCssHelper";

export const Btn = styled("button")`
	${twToCss("relative rounded-[20px] w-full py-2.5 px-6 flex items-center gap-1 bg-red-extraDark")};

	&.size {
		&_XS {
			${twToCss("h-6 py-1 px-3")};
		}
	}
`;
